import { runQuery, runMutation } from '../graphQl'
import http from '../http/index'
import config from '@/config'
import store from '../../store'

import {
  GetMaterialMasterDataQuery,
  GetMaterialMasterForBomQuery,
  CreateMaterialMaster,
  UpdateMaterialMasterDataQuery,
  GetSingleMaterialMasterDataQuery,
  getProductsUsingMaterialQuery,
  UpdateMaterialStatusQuery,
  unitOfMaterial,
  weightUnit,
  materialGroup,
  resourceGroup,
  ChangeResourceStatusQuery,
  addressLocation,
  removeAttachmentsDocQuery,
  checkMaterialID,
  getProjectLevelProductsUsingMaterialQuery,
  upadateMaterialFormsQuery,
  GetMaterialMasterDataQueryForCsv,
  attachDocToMaterailMutation,
  createMaterialMasterMutation,
  GetJobOrderMaterialLinksQuery,
  UpdateMaterialWorkflowLinkMutation,
  checkForAnyRunningInstancesQuery,
  GetMaterialInventoryDetailsQuery,
  AlternateMaterialsQuery,
  AddAlternateMaterialQuery,
  getMaterialCustomList,
  updateDefaultVendor,
  getResourceTypesQuery,
  getMaterialDefualtVendorQuery,
  getWfListBasedOnIdQuery,
  CheckCustomMaterialIdExistenceQuery,
  GetAllWFLifeCycle,
  CreateLinkProductCodeMutation
} from '../query/materialMaster'

export const GetMaterialMasterData = (filter, csvQuery, sorting, collaborator = false) => {
  const conditions = []
  let orderBy = { created_on: 'desc' }
  if (sorting === '2') {
    orderBy = { created_on: 'asc' }
  } else if (sorting === '1') {
    orderBy = { created_on: 'desc' }
  } else if (sorting === '3') {
    orderBy = { material_name: 'asc' }
  } else if (sorting === '4') orderBy = { material_name: 'desc' }
  filter.orderBy = orderBy
  if (filter.tagId) {
    conditions.push({
      tag_materials: { tag_id: { _eq: filter.tagId } }
    })
  }
  if (filter.type === 'material') {
    conditions.push({
      type: {
        _eq: 1
      }
    })
  } else if (filter.type === 'resource') {
    conditions.push({
      type: {
        _eq: 2
      }
    })
  }
  filter.type = undefined
  if (filter.searchKeyword) {
    conditions.push({
      _or: [
        { custom_material_id: { _ilike: filter.searchKeyword } },
        { erp_material_id: { _ilike: filter.searchKeyword } },
        { material_description: { _ilike: filter.searchKeyword } },
        { material_name: { _ilike: filter.searchKeyword } },
        { plm_material_id: { _ilike: filter.searchKeyword } },
        {
          material_product_code: { product_code: { _ilike: filter.searchKeyword } }
        }
      ]
    })
  }
  if (filter.customListItmes) {
    if (Object.hasOwn(filter.customListItmes, 'resource_group')) {
      conditions.push({
        resource_group: { _eq: filter.customListItmes.resource_group.id }
      })
    }
    if (Object.hasOwn(filter.customListItmes, 'material_group')) {
      conditions.push({
        material_group: { _eq: filter.customListItmes.material_group.id }
      })
    }
    if (Object.hasOwn(filter.customListItmes, 'unit_of_material')) {
      conditions.push({
        unit_of_material: { _eq: filter.customListItmes?.unit_of_material?.id }
      })
    }
    if (Object.hasOwn(filter.customListItmes, 'weight_unit')) {
      conditions.push({
        weight_unit: { _eq: filter.customListItmes.weight_unit?.id }
      })
    }
    if (Object.hasOwn(filter.customListItmes, 'storage_loc')) {
      conditions.push({
        storage_loc: { _eq: filter.customListItmes.storage_loc.id }
      })
    }
  }

  if (filter.effectiveDate) {
    if (filter.effectiveDate.from && filter.effectiveDate.to) {
      conditions.push({
        effective_date: { _gte: new Date(filter.effectiveDate.from), _lte: new Date(filter.effectiveDate.to) }
      })
    } else if (filter.effectiveDate.from) {
      conditions.push({
        effective_date: { _gte: new Date(filter.effectiveDate.from) }
      })
    } else if (filter.effectiveDate.to) {
      conditions.push({
        effective_date: { _lte: new Date(filter.effectiveDate.to) }
      })
    }
  }
  if (filter.leadtime) {
    if ((filter.leadtime.from || filter.leadtime.from === 0) && filter.leadtime.to) {
      conditions.push({
        lead_time: { _gte: parseInt(filter.leadtime.from), _lte: parseInt(filter.leadtime.to) }
      })
    } else if (filter.leadtime.from || filter.leadtime.from === 0) {
      conditions.push({
        lead_time: { _gte: parseInt(filter.leadtime.from) }
      })
    } else if (filter.leadtime.to) {
      conditions.push({
        lead_time: { _lte: parseInt(filter.leadtime.to) }
      })
    }
  }
  if (filter.resourseStatusId) {
    conditions.push({
      resource_state_value: { id: { _eq: parseInt(filter.resourseStatusId) } }
    })
  }
  if (filter.id) {
    conditions.push({
      id: { _eq: filter.id }
    })
    filter.id = undefined
  }
  filter.resourseStatusId = undefined
  if (conditions.length > 0) {
    filter.conditions = {
      _and: conditions
    }
  }
  filter.effectiveDate = undefined
  filter.leadtime = undefined
  filter.searchKeyword = undefined
  filter.tagId = undefined
  filter.customListItmes = undefined
  if (csvQuery) {
    filter.orderBy = undefined
  } else {
    filter.collaborator = collaborator
  }
  return runQuery(csvQuery ? GetMaterialMasterDataQueryForCsv() : GetMaterialMasterDataQuery(), filter, 'tenant')
}

export const getResourceTypes = () => {
  return runQuery(getResourceTypesQuery(), {}, 'tenant')
}

export const GetSingleMaterialMasterData = (filter) => {
  return runQuery(GetSingleMaterialMasterDataQuery(), filter, 'tenant')
}

export const searchExternalMaterials = (query) => {
  if (!query || query.trim() === '') {
    return Promise.resolve({ results: [], total_count: 0 })
  }

  const EXTERNAL_SEARCH_API = `${config.serverEndpoint}/materials/search`
  const url = `${EXTERNAL_SEARCH_API}?q=${encodeURIComponent(query)}&use_variations=true&limit=15`

  return http.GET(url, 'tenant')
}

export const GetMaterialMasterForBom = ({ filter, project = false, feature }, fetchOnlyMaterialsWithWorkflow = false) => {
  const conditions = []
  if (fetchOnlyMaterialsWithWorkflow) {
    conditions.push({
      workflow_template_id: { _is_null: false }
    })
  }
  if (filter.searchKeyword) {
    conditions.push({
      _or: [
        { custom_material_id: { _ilike: filter.searchKeyword } },
        { erp_material_id: { _ilike: filter.searchKeyword } },
        { material_description: { _ilike: filter.searchKeyword } },
        { material_name: { _ilike: filter.searchKeyword } },
        { plm_material_id: { _ilike: filter.searchKeyword } },
        {
          material_product_code: { product_code: { _ilike: filter.searchKeyword } }
        }
      ]
    })
  }
  if (filter.tagId) {
    conditions.push({
      tag_materials: { tag_id: { _eq: filter.tagId } }
    })
  }
  if (filter.resourceId) {
    conditions.push({
      resource_group: { _eq: filter.resourceId }
    })
  }
  conditions.push({
    status: { _neq: 2 },
    type: {
      _in: [1, 2]
    }

  })
  if (feature === 'vendorMaterial') {
    // on this condition only need  material_type_value= Buy  and need t exclude resources
    conditions.push({
      type: { _eq: config.MATERIAL_TYPE_INVERTED.MATERIAL }
    },
    { material_type_value: { name: { _eq: config.MATERIAL_TYPE_VALUE_NAME.BUY } } }
    )
  }
  if (conditions.length > 0) {
    filter.conditions = {
      _and: conditions
    }
  }
  filter.searchKeyword = undefined
  filter.tagId = undefined
  filter.resourceId = undefined
  return runQuery(GetMaterialMasterForBomQuery(), filter, project ? 'project' : 'tenant')
}

export const GetJobOrderMaterialLinks = (filter, sort, isOnProjectLevel) => {
  const conditions = []
  const limit = filter?.perPage || 10
  const offset = filter.jump || 0
  let orderBy = { workflow_instance: { created_on: 'desc' } } // default sorting
  if (sort === '2') {
    orderBy = { workflow_instance: { created_on: 'asc' } }
  } else if (sort === '1') {
    orderBy = { workflow_instance: { created_on: 'desc' } }
  } else if (sort === '3') {
    orderBy = { workflow_instance: { core_material_master: { material_name: 'asc' } } }
  } else if (sort === '4') {
    orderBy = { workflow_instance: { core_material_master: { material_name: 'desc' } } }
  }
  // Handle search keyword
  if (filter.searchKeyword) {
    conditions.push({
      _or: [
        {
          workflow_instance: {
            core_material_master: {
              material_name: { _ilike: filter.searchKeyword }
            }
          }
        },
        {
          workflow_instance: {
            core_material_master: {
              material_product_code: {
                product_code: { _ilike: filter.searchKeyword }
              }
            }
          }
        },
        {
          workflow_instance: {
            current_instance_step: {
              workflow_step: {
                name: { _ilike: filter.searchKeyword }
              }
            }
          }
        },
        {
          core_form: {
            forms_company_list: {
              company_name: { _ilike: filter.searchKeyword }
            }
          }
        }
      ]
    })
  }

  if (filter.createdDate) {
    if (filter.createdDate.from && filter.createdDate.to) {
      const toDate = new Date(filter.createdDate.to)
      toDate.setHours(23, 59, 59, 999)

      conditions.push({
        workflow_instance: {
          created_on: {
            _gte: new Date(filter.createdDate.from),
            _lte: toDate
          }
        }
      })
    } else if (filter.createdDate.from) {
      conditions.push({
        workflow_instance: {
          created_on: { _gte: new Date(filter.createdDate.from) }
        }
      })
    } else if (filter.createdDate.to) {
      const toDate = new Date(filter.createdDate.to)
      toDate.setHours(23, 59, 59, 999)

      conditions.push({
        workflow_instance: {
          created_on: { _lte: toDate }
        }
      })
    }
  }

  // Build final filter object
  const queryFilter = {
    limit,
    offset,
    orderBy
  }

  if (conditions.length > 0) {
    queryFilter.conditions = {
      _and: conditions
    }
  }
  let token = 'tenant'
  if (store?.getters?.isOnFactoryLevel) {
    token = 'factory'
  } else if (isOnProjectLevel) {
    token = 'project'
    conditions.push({
      core_form: {
        project_id: { _is_null: false }
      }
    })
  }
  return runQuery(GetJobOrderMaterialLinksQuery(), queryFilter, token)
}

export const AddAlternateMaterial = (variables) => {
  return runMutation(AddAlternateMaterialQuery(), variables, 'tenant')
}

export const AlternateMaterials = (id) => {
  return runQuery(AlternateMaterialsQuery(), { id }, 'tenant')
}
export const UpdateMaterialMasterData = (variables) => {
  return runMutation(UpdateMaterialMasterDataQuery(), variables, 'tenant')
}

export const UpdateMaterialWorkflowLink = (id, workflowTemplateId) => {
  return runMutation(UpdateMaterialWorkflowLinkMutation(), { id, workflowTemplateId }, 'tenant')
}

export const CreateMaterialMasterData = (variables) => {
  return runMutation(CreateMaterialMaster(), variables, 'tenant')
}

export const GetProductsUsingMaterialQuery = (materialId) => {
  if (store.getters?.isOnProjectLevel) {
    const projectId = store.getters.openProjectId
    return runQuery(getProjectLevelProductsUsingMaterialQuery(), { material_id: materialId, project_id: projectId }, 'project')
  } else {
    return runQuery(getProductsUsingMaterialQuery(), { material_id: materialId }, 'tenant')
  }
}

export const UpdateMaterialStatus = (id, status) => {
  return runMutation(UpdateMaterialStatusQuery(), {
    id, status
  }, 'tenant')
}

export const UnitOfMaterial = () => {
  return runQuery(unitOfMaterial(), null, 'tenant')
}

export const WeightUnit = () => {
  return runQuery(weightUnit(), null, 'tenant')
}

export const MaterialGroup = () => {
  return runQuery(materialGroup(), null, 'tenant')
}

export const ResourceGroup = (name) => {
  return runQuery(resourceGroup(), { name }, 'tenant')
}

export const ChangeResourceStatus = (status, id) => {
  return runMutation(ChangeResourceStatusQuery(), { id, status }, 'tenant')
}

export const AddressLocation = () => {
  return runQuery(addressLocation(), null, 'tenant')
}
// to be delelted
// export const attchMaterilIdToDoc = (materialId, docId) => {
//   return runMutation(attchMaterilIdToDocQuery(), {
//     material_id: materialId, docId
//   }, 'tenant')
// }
export const attachDocToMaterail = (attachDocData) => {
  return runMutation(attachDocToMaterailMutation(), {
    data: attachDocData
  }, 'tenant')
}
export const removeAttachments = (materialId, docIds) => {
  return runMutation(removeAttachmentsDocQuery(), {
    docIds,
    materialId
  }, 'tenant')
}

export const getMaterialDataByApi = (body) => {
  return http.POST(config.serverEndpoint + '/filter/materials', body, 'tenant')
}

export const CheckMaterialID = (customMaterialId) => {
  return runQuery(checkMaterialID(), {
    materialID: customMaterialId
  }, 'tenant')
}
export const GetMaterialCustomList = () => {
  return runQuery(getMaterialCustomList(), null, 'tenant')
}
export const upadateMaterialForms = (materialId, formId) => {
  return runQuery(upadateMaterialFormsQuery(), {
    materialId, formId
  }, 'tenant')
}

export const createMaterialMaster = (body) => {
  const payload = { ...body }
  if (!Array.isArray(payload.docInput) || payload.docInput.length === 0) {
    payload.docInput = undefined
  }
  return runMutation(createMaterialMasterMutation(), payload, 'tenant')
}

export const CreateLinkProductCode = (variables) => {
  console.log(variables)
  return runMutation(CreateLinkProductCodeMutation(), variables, 'tenant')
}

export const checkForAnyRunningInstances = (id) => {
  return runQuery(checkForAnyRunningInstancesQuery(), { id }, 'tenant')
}

export const getMaterialInventoryDetails = (materialId) => {
  const conditions = {
    form_type_id: { _eq: 5 },
    status: { _eq: 4 }
  }
  return runQuery(GetMaterialInventoryDetailsQuery(), { conditions, materialId }, 'tenant')
}

export const updatedefaultVenodor = (materialId, vendorId) => {
  return runMutation(updateDefaultVendor(), { materialId, vendorId }, 'tenant')
}
export const getMaterialDefualtVendor = (materialIds) => {
  return runQuery(getMaterialDefualtVendorQuery(), { materialIds }, 'tenant')
}
export const getMaterialHistory = async (id) => {
  const tokenType = 'tenant'
  return http.GET(config.serverEndpoint + `/materials/history/${id}`, tokenType)
}
export const getWfListBasedOnId = async ({ bomId = null, materialId = null, documentId = null, category = null }) => {
  let tokenType = 'tenant'
  if (store.getters?.isOnProjectLevel) tokenType = 'project'

  return runQuery(getWfListBasedOnIdQuery(), {
    bomId: bomId ?? undefined,
    materialId: materialId ?? undefined,
    documentId: documentId ?? undefined,
    category: category ?? undefined
  }, tokenType)
}

export const CheckCustomMaterialIdExistence = (customMaterialId) => {
  return runQuery(CheckCustomMaterialIdExistenceQuery(), { customMaterialId }, 'tenant')
}

export const getAllWFLifeCycle = (id) => {
  return runQuery(GetAllWFLifeCycle(), { id }, 'tenant')
}
